module.exports = __webpack_public_path__ + "static/media/logo-dsprivate.0dbaeafd.png";